/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { VerifiedCreatorRegistry } from "../VerifiedCreatorRegistry";

export class VerifiedCreatorRegistry__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<VerifiedCreatorRegistry> {
    return super.deploy(overrides || {}) as Promise<VerifiedCreatorRegistry>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): VerifiedCreatorRegistry {
    return super.attach(address) as VerifiedCreatorRegistry;
  }
  connect(signer: Signer): VerifiedCreatorRegistry__factory {
    return super.connect(signer) as VerifiedCreatorRegistry__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): VerifiedCreatorRegistry {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as VerifiedCreatorRegistry;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "verified",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "image",
        type: "string",
      },
    ],
    name: "AddressModified",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "creatorProfiles",
    outputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "verified",
        type: "bool",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "image",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "verified",
        type: "bool",
      },
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "image",
        type: "string",
      },
    ],
    name: "modifyCreator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
